<template>
  <div class="ccui-app-box-iframe-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button type="table-top-active" size="mini">{{
              `技术评分${
                subPackageFlag == "0" ? "" : "(包件：" + packName + ")"
              }`
            }}</el-button>
          </div>
        </div>
        <div class="exportStyle">
          <el-button type="single-number" v-preventReClick @click="exportExcel"
            >导出</el-button
          >
          <el-upload
            ref="importExcel1"
            class="upload-demo tow"
            :data="uploadFormData"
            :action="uploadForm.action"
            :on-success="uploadSuccess"
            :show-file-list="false"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload"
            :headers="uploadForm.headers"
            multiple
          >
            <el-button type="single-number">导入</el-button>
          </el-upload>
        </div>
        <el-table
          :data="tableData"
          border
          empty-text="该评标项目中，没有有效的分包商投标信息！"
        >
          <template v-for="(item, index) in columns">
            <el-table-column
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
              v-if="item.labelChild && item.labelChild.length > 0"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>{{ item.label }}
                </template>
                <template v-else>{{ item.label }}</template>
              </template>
              <el-table-column
                v-for="(child, indexch) in item.labelChild"
                :key="indexch"
                align="center"
                v-bind="child"
              >
                <template
                  v-if="child.labelChild && child.labelChild.length > 0"
                >
                  <el-table-column
                    v-for="(childTwo, indexchTwo) in child.labelChild"
                    :key="indexchTwo"
                    align="center"
                    v-bind="childTwo"
                  >
                    <template slot="header">
                      <div class="el-tooltip">{{ childTwo.label }}</div>
                    </template>
                    <!--                    <template-->
                    <!--                      v-if="-->
                    <!--                        childTwo.labelChild && childTwo.labelChild.length > 0-->
                    <!--                      "-->
                    <!--                    >-->
                    <template slot-scope="scope">
                      <el-input
                        v-if="child.type == 'input'"
                        v-model="scope.row[scope.column.property]"
                        v-limitdecimal.two
                        @change="
                          changeScore(
                            $event,
                            scope.column.property,
                            scope.$index
                          )
                        "
                        :min="0"
                        size="mini"
                      ></el-input>
                    </template>
                    <!--                      <el-table-column-->
                    <!--                        v-for="(childThree,-->
                    <!--                        indexchThree) in childTwo.labelChild"-->
                    <!--                        :key="indexchThree"-->
                    <!--                        align="center"-->
                    <!--                        v-bind="childThree"-->
                    <!--                      >-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                          <el-input-->
                    <!--                            v-if="child.type == 'input'"-->
                    <!--                            v-limitdecimal.two-->
                    <!--                            v-model="scope.row[scope.column.property]"-->
                    <!--                            @change="-->
                    <!--                              changeScore(-->
                    <!--                                $event,-->
                    <!--                                scope.column.property,-->
                    <!--                                scope.$index-->
                    <!--                              )-->
                    <!--                            "-->
                    <!--                            :min="0"-->
                    <!--                            size="mini"-->
                    <!--                          ></el-input>-->
                    <!--                        </template>-->
                    <!--                      </el-table-column>-->
                    <!--                    </template>-->
                  </el-table-column>
                </template>
              </el-table-column>
              <template slot-scope="scope">
                <el-input
                  maxlength="150"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  v-if="item.type == 'input'"
                  v-model="scope.row.scoreDesc"
                ></el-input>
                <span v-else-if="item.money">{{
                  new BigNumber(scope.row[item.prop]).toFormat(8)
                }}</span>
                <span v-else-if="item.prop == 'supScore'">{{
                  new BigNumber(scope.row[item.prop]).toFormat(2)
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :show-overflow-tooltip="true"
              v-bind="item"
              v-else-if="!item.labelChild"
            >
              <template slot="header">
                <template v-if="item.required">
                  <span class="star">*</span>{{ item.label }}
                </template>
                <template v-else>{{ item.label }}</template>
              </template>
              <template slot-scope="scope">
                <el-input
                  maxlength="150"
                  show-word-limit
                  class="input-short word-limit input-width;"
                  v-if="item.type == 'input'"
                  v-model="scope.row.scoreDesc"
                ></el-input>
                <el-button
                  v-else-if="item.type == 'link'"
                  size="mini"
                  type="text"
                  @click="viewBidFile(scope.row)"
                  >查看投标文件</el-button
                >
                <span v-else-if="item.money">{{
                  new BigNumber(scope.row[item.prop]).toFormat(8)
                }}</span>
                <span v-else-if="item.prop == 'supScore'">{{
                  new BigNumber(scope.row[item.prop]).toFormat(2)
                }}</span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
    <div class="operate">
      <el-button
        type="text"
        icon="icon-ccui-save"
        v-preventReClick
        @click="dealExpertSupScore"
        >保存</el-button
      >
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="分包商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supPackQuoteId="formData.supPackQuoteId"
        :supCode="formData.supCode"
        :packId="formData.packId"
      ></supplierBidDetails>
      <div slot="footer"></div>
    </el-dialog>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/subSourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/subSourcingFlow/components/breadcrumb-sourcing.vue";
import {
  scpQryExpertSupPackQuoteToScoreApi,
  scpDealExpertSupScoreApi,
  scpQryExpertSupPackQuoteScoreApi,
  scpListPurchaseSchemePackageApi,
  scpExportSupQuoteScoreFile
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
import Cookies from "js-cookie";
export default {
  name: "addSkiiScore",
  components: {
    supplierBidDetails,
    breadcrumbSourcing
  },
  props: {
    type: {
      type: Number,
      default: 0 // type 0:新增 1：编辑
    },
    packId: {
      type: String,
      default: "" // 包件packId
    }
  },
  data() {
    let unit = JSON.parse(sessionStorage.getItem("moneyData")).unit;
    return {
      BigNumber: BigNumber,
      breadcrumbData: {
        titname: "技术评分"
      },
      tableData: [],
      headers: [],
      dialogVisible: false,
      formData: {
        supQuoteId: 0, // 分包商报价ID
        supPackQuoteId: "",
        supCode: "", // 分包商编号
        packId: "" //包件id
      },
      columns: [],
      columnCopy: [
        {
          prop: "id",
          label: "序号",
          width: 55,
          fixed: true
          // fixed: "left"
        },
        {
          prop: "supName",
          label: "分包商",
          width: 200,
          fixed: true
          // fixed: "left"
        },
        {
          prop: "industryTypeName",
          label: "行业类型",
          width: 120
        },
        {
          prop: "companyTypeName",
          label: "企业规模",
          width: 120
        },
        /*  {
          prop: "priceAmount",
          label: "投标金额（" + unit + "）",
          width: 170,
          money: true
        }, */
        {
          prop: "taxAmount",
          label: "税额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "noTaxPriceAmount",
          label: "不含税金额（" + unit + "）",
          width: 200,
          align: "right",
          money: true
        },
        {
          prop: "priceAmount",
          label: "含税金额（" + unit + "）",
          width: 180,
          align: "right",
          money: true
        },
        {
          prop: "查看投标文件",
          label: "投标文件",
          width: 170,
          type: "link"
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术",
          labelChild: [],
          align: "center",
          required: true
        },
        {
          prop: "sscScoreItemBOS",
          label: "技术加分项",
          labelChild: [],
          align: "center",
          required: true
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 110
          // money: true
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 350,
          type: "input"
        }
      ],
      packName: "",
      subPackageFlag: "1", // 是否分包 1分包0不分包
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL +
            "/apis/bid-scp/bidc/getImportExpertScoreContent"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      uploadFormData: {}
    };
  },
  mounted() {
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      this.columnCopy.splice(4, 1);
      this.columns = this.columnCopy;
    } else {
      this.columns = this.columnCopy;
    }
    this.cumputeData();
    this.getPackData();
  },
  methods: {
    init() {
      this.cumputeData();
      this.getPackData();
    },
    cumputeData() {
      if (
        this.$router.history.current.query.type &&
        this.$router.history.current.query.type == "1"
      ) {
        scpQryExpertSupPackQuoteScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          scoreItem: "0"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            let labelChild = [];
            let labelChild2 = [];
            res.data.data.forEach((item, index) => {
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS = item.sscSupScoreBOS;
              item.sscScoreBOS.forEach(sscScoreBOItem => {
                sscScoreBOItem.sscScoreItemBOS =
                  sscScoreBOItem.sscSupScoreItemBOS;
                sscScoreBOItem.sscScoreItemBOS.forEach(sscScoreItemBO => {
                  if (!sscScoreItemBO.supScore) {
                    sscScoreItemBO.supScore = 0;
                  }
                  item.scoreRule = sscScoreItemBO.scoreRule;
                  item.scoreWeight = sscScoreItemBO.scoreWeight;
                  item.scoreStandard = sscScoreItemBO.scoreStandard;
                  let props =
                    "supScore-" +
                    sscScoreBOItem.scoreItem +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[props] = sscScoreItemBO.supScore;
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    sscScoreItemBO.scoreRule +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[scoreWeightProps] =
                    sscScoreItemBO.scoreWeight &&
                    new BigNumber(sscScoreItemBO.scoreWeight).toFormat(2);
                  if (sscScoreBOItem.scoreItem === "0") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ===
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length === 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 120
                          }
                        ]
                      });
                    }
                  }
                  if (sscScoreBOItem.scoreItem === "2") {
                    if (
                      labelChild2.filter(item => {
                        return (
                          item.prop ===
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length === 0
                    ) {
                      labelChild2.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 120
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            if (labelChild.length < 3) {
              if (this.purchaseType == "50" || this.purchaseType == "53") {
                delete this.columns[9].width;
              } else {
                delete this.columns[10].width;
              }
            }
            this.columns[8].labelChild = labelChild;
            this.columns[9].labelChild = labelChild2;
            this.tableData = res.data.data;
          }
        });
      } else {
        scpQryExpertSupPackQuoteToScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          scoreItem: "0"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            let labelChild = [];
            let labelChild2 = [];
            res.data.data.forEach((item, index) => {
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS.forEach(sscScoreBOItem => {
                sscScoreBOItem.sscScoreItemBOS.forEach(sscScoreItemBO => {
                  if (!sscScoreItemBO.supScore) {
                    sscScoreItemBO.supScore = 0;
                  }
                  item.scoreRule = sscScoreItemBO.scoreRule;
                  item.scoreWeight = sscScoreItemBO.scoreWeight;
                  item.scoreStandard = sscScoreItemBO.scoreStandard;
                  let props =
                    "supScore-" +
                    sscScoreBOItem.scoreItem +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[props] = sscScoreItemBO.supScore;
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    sscScoreItemBO.scoreRule +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[scoreWeightProps] =
                    sscScoreItemBO.scoreWeight &&
                    new BigNumber(sscScoreItemBO.scoreWeight).toFormat(2);
                  if (sscScoreBOItem.scoreItem === "0") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ===
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length === 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 120
                          }
                        ]
                      });
                    }
                  }
                  if (sscScoreBOItem.scoreItem === "2") {
                    if (
                      labelChild2.filter(item => {
                        return (
                          item.prop ===
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length === 0
                    ) {
                      labelChild2.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 120,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 120
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              this.columns[7].labelChild = labelChild;
            } else {
              this.columns[8].labelChild = labelChild;
              this.columns[9].labelChild = labelChild2;
            }

            this.tableData = res.data.data;
          }
        });
      }
    },
    getPackData() {
      let _this = this;
      scpListPurchaseSchemePackageApi({
        pageNo: -1,
        pageSize: -1,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // subPackageFlag 是否分包 1分包0不分包
        _this.subPackageFlag = res.data.data.subPackageFlag;
        let packId = _this.packId
          ? _this.packId
          : _this.$router.history.current.query.packId;
        res.data.data.purchaseSchemePackageList.forEach(item => {
          if (item.packId == packId) {
            _this.packName = item.packName;
          }
        });
      });
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.formData.packId = this.packId
        ? this.packId
        : this.$router.history.current.query.packId;
      this.dialogVisible = true;
    },
    // 改变分数计算汇总得分
    changeScore(value, prop, index) {
      // 直接验证不能大于权重并提示
      let total = 0;
      let flag = true;
      let message = "";
      try {
        for (let key in this.tableData[index]) {
          if (key.includes("supScore-")) {
            // 不能大于权重大小
            for (let keyWeight in this.tableData[index]) {
              if (keyWeight.includes("maxScoreWeight-")) {
                let scoreItemId = key.substring(11);
                let scoreWeightItemId = keyWeight.substring(
                  keyWeight.lastIndexOf("-") + 1
                );
                let scoreRule = keyWeight.substring(
                  15,
                  keyWeight.lastIndexOf("-")
                );
                if (scoreItemId === scoreWeightItemId) {
                  if (
                    Number(this.tableData[index][key]) >
                    Number(this.tableData[index][keyWeight])
                  ) {
                    flag = false;
                    this.tableData[index][prop] = 0;
                    message =
                      "第" +
                      (index + 1) +
                      "行的" +
                      scoreRule +
                      "的得分不允许大于细则权重" +
                      this.tableData[index][keyWeight] +
                      "分，谢谢您的配合！";
                    throw Error();
                  }
                }
              }
            }
            total = window.$computeUtil.getPlus(
              total,
              this.tableData[index][key] || "0"
            );
            total = new BigNumber(total).toFormat(2);
          }
        }
      } catch (e) {
        console.log(e);
      }
      if (flag) {
        this.$set(this.tableData[index], "supScore", total);
      } else {
        this.$message({
          message: message,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 保存
    dealExpertSupScore() {
      if (this.tableData.length === 0) {
        this.$message({
          message: `分包商已全部淘汰，请联系采购承办人${
            JSON.parse(sessionStorage.getItem("expertSourceData")).expertName
          }进行流标操作`,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      } else {
        let sscExpertSupScoreBOS = [];
        let flag = true;
        let message = "";
        console.log("tableData", this.tableData);
        try {
          this.tableData.forEach((item, index) => {
            let tempSscExpertSupScoreBOS = []; // 技术商务评分的时候临时存的数据
            let scoreItemIdArr = [];
            let obj = {};
            obj.supCode = item.supCode;
            obj.supName = item.supName;
            obj.supScore = item.supScore;
            obj.scoreDesc = item.scoreDesc;
            // if (!item.scoreDesc) {
            //   flag = false;
            //   message = "第" + (index + 1) + "行的打分说明不能为空";
            //   throw Error();
            // }
            // let leng = this.validateTextLength(item.scoreDesc);
            // if (leng > 150) {
            //   flag = false;
            //   message =
            //     "第" + (index + 1) + "行的打分说明长度不能大于150，请重新输入";
            //   throw Error();
            // }
            for (let key in item) {
              if (key.includes("supScore-")) {
                // 不能大于权重大小
                for (let keyWeight in item) {
                  if (keyWeight.includes("maxScoreWeight-")) {
                    obj.scoreItem = key.substring(9, 10);
                    let scoreItemId = key.substring(11);
                    let scoreWeightItemId = keyWeight.substring(
                      keyWeight.lastIndexOf("-") + 1
                    );
                    let scoreRule = keyWeight.substring(
                      15,
                      keyWeight.lastIndexOf("-")
                    );
                    if (scoreItemId === scoreWeightItemId) {
                      if (
                        Number(this.tableData[index][key]) >
                        Number(this.tableData[index][keyWeight])
                      ) {
                        flag = false;
                        message =
                          "第" +
                          (index + 1) +
                          "行的" +
                          scoreRule +
                          "的得分不允许大于细则权重" +
                          this.tableData[index][keyWeight] +
                          "分，谢谢您的配合！";
                        throw Error();
                      }
                    }
                  }
                }
                // if (!Number(this.tableData[index][key])) {
                //   flag = false;
                //   message = "第" + (index + 1) + "行的评分规则内容不能为空";
                //   throw Error();
                // }
                if (!scoreItemIdArr.includes(key)) {
                  scoreItemIdArr.push(key);
                  let sscScoreObj = {};
                  sscScoreObj.scoreItem = obj.scoreItem;
                  sscScoreObj.scoreItemId = key.substring(11);
                  sscScoreObj.supScore = this.tableData[index][key];
                  tempSscExpertSupScoreBOS.push(sscScoreObj);
                }
              }
            }
            let skillSscSupScoreItemBOS = []; // 技术
            let commonSscSupScoreItemBOS2 = []; // 技术加分项
            tempSscExpertSupScoreBOS.forEach(temp => {
              if (temp.scoreItem == "0") {
                // 技术
                skillSscSupScoreItemBOS.push({ ...temp, obj });
              } else if (temp.scoreItem == "2") {
                // 商务
                commonSscSupScoreItemBOS2.push({ ...temp, obj });
              }
            });
            skillSscSupScoreItemBOS.length > 0 &&
              sscExpertSupScoreBOS.push({
                scoreItem: "0",
                supCode: item.supCode,
                supName: item.supName,
                supScore: item.supScore,
                scoreDesc: item.scoreDesc,
                sscSupScoreItemBOS: skillSscSupScoreItemBOS,
                noTaxPrice: item.noTaxPriceAmount,
                priceAmount: item.priceAmount,
                supJoinId: item.supJoinId,
                supPackQuoteId: item.supPackQuoteId,
                supQuoteId: item.supQuoteId,
                taxAmount: item.taxAmount
              });
            commonSscSupScoreItemBOS2.length > 0 &&
              sscExpertSupScoreBOS.push({
                scoreItem: "2",
                supCode: item.supCode,
                supName: item.supName,
                supScore: item.supScore,
                scoreDesc: item.scoreDesc,
                sscSupScoreItemBOS: commonSscSupScoreItemBOS2,
                noTaxPrice: item.noTaxPriceAmount,
                priceAmount: item.priceAmount,
                supJoinId: item.supJoinId,
                supPackQuoteId: item.supPackQuoteId,
                supQuoteId: item.supQuoteId,
                taxAmount: item.taxAmount
              });
          });
        } catch (e) {
          console.log(e);
        }
        if (flag) {
          let param = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            packId: this.packId
              ? this.packId
              : this.$router.history.current.query.packId,
            packName: this.packName,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            expertName: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .expertName,
            purStep: this.$router.history.current.query.menuKey,
            scoreType: "0",
            sscExpertSupScoreBOS: sscExpertSupScoreBOS,
            isShowLoading: true
          };
          scpDealExpertSupScoreApi(param).then(res => {
            if (res.data.code == "0") {
              this.init();
              this.$router.push({
                name: "scpSkiiScoreList",
                query: {
                  a: this.$router.history.current.query.a,
                  menuKey: this.$router.history.current.query.menuKey,
                  evaPurStep: this.$router.history.current.query.evaPurStep
                }
              });
              this.$message({
                message: "技术评分保存成功",
                type: "success",
                duration: 3000,
                showClose: true,
                ccuiCustom: true
              });
            }
          });
        } else {
          this.$message({
            message: message,
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      }
    },
    //导出评分模版
    exportExcel() {
      console.log("columns", this.columns);
      let sortIdsList = ["技术", "商务", "技术加分项", "商务加分项"];

      let sortIds = [];
      this.columns.forEach(item => {
        if (sortIdsList.includes(item.label) && item.labelChild.length > 0) {
          console.log("aaa");
          for (let i = 0; i < sortIdsList.length; i++) {
            if (item.label == sortIdsList[i]) {
              sortIds.push(i);
            }
          }
        }
      });
      sortIds = sortIds.join(",");
      console.log("sortIds", sortIds);
      console.log("导出");
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        packId: this.packId
          ? this.packId
          : this.$router.history.current.query.packId,
        joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .joinExpertId,
        scoreItem: "0",
        sortIds
      };
      scpExportSupQuoteScoreFile(param).then(res => {
        if (res) {
          let openUrl = document.createElement("a");
          openUrl.style.display = "none";
          openUrl.href = res.data.data.fileUrl;
          openUrl.setAttribute("download", "评分模板.xlsx");
          document.body.appendChild(openUrl);
          openUrl.click();
        }
      });
    },
    //导入模板
    beforeAvatarUpload(file) {
      this.uploadLoading = true;
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "XLSX" ||
        testmsg === "XLS";
      if (!isLt50) {
        this.$message({
          message: "文件大小不可超过50M！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("文件大小不可超过50M！");
      }
      //是否有后缀
      let fileType = file.name.indexOf(".") != -1;
      if (!extension && fileType) {
        this.$message({
          message: "上传文件格式错误！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && (extension || !fileType);
    },
    uploadSuccess(res, file, fileList) {
      let schemeId = JSON.parse(sessionStorage.getItem("expertSourceData"))
        .schemeId;
      let packId = this.packId
        ? this.packId
        : this.$router.history.current.query.packId;
      let lastPackId = packId ? packId : null;
      if (
        res.data.schemeId == schemeId &&
        res.data.packId == lastPackId &&
        res.data.scoreType == "0"
      ) {
        res.data.sscExpertSupScoreBOS.forEach(item => {
          item.sscSupScoreItemBOS.forEach(bb => {
            let props = "supScore-" + bb.scoreItem + "-" + bb.scoreItemId;
            this.tableData.forEach((cc, index) => {
              if (cc.supCode == item.supCode) {
                cc[props] =
                  bb.supScore !== ""
                    ? new BigNumber(bb.supScore).toFormat(2)
                    : "";
                cc.supScore =
                  item.supScore !== ""
                    ? new BigNumber(item.supScore).toFormat(2)
                    : "";
                let leng = this.validateTextLength(item.scoreDesc);
                if (leng > 150) {
                  this.$message({
                    message:
                      "第" +
                      (index + 1) +
                      "行的打分说明长度不能大于150，请重新输入",
                    type: "error",
                    duration: 3000,
                    showClose: true,
                    ccuiCustom: true
                  });

                  item.scoreDesc = "";
                  throw Error();
                } else {
                  this.$set(cc, "scoreDesc", item.scoreDesc);
                }
              }
            });
          });
        });
      } else {
        this.$message({
          message: "导入模板与当前评标表不一致，请重新导入",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
    },
    //判断文字长度
    validateTextLength(value) {
      // 中文、中文标点、全角字符按1长度，英文、英文符号、数字按0.5长度计算
      let cnReg = /([\u4e00-\u9fa5]|[\u3000-\u303F]|[\uFF00-\uFF60])/g;
      let mat = value.match(cnReg);
      let length;
      if (mat) {
        length = mat.length + (value.length - mat.length) * 0.5;
        return length;
      } else {
        return value.length * 0.5;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/ .el-table td {
  padding: 0 !important;
}
.exportStyle {
  text-align: right;
  margin-bottom: 16px;
  .upload-demo {
    float: right;
    margin-left: 16px;
  }
}
</style>
